import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AvailableAppsRaw = React.lazy(() => import(/* webpackChunkName: "AvailableApps" */ './AvailableApps'));
export const AvailableApps = () => (React.createElement(Page, { title: "Available Appearance", description: "Available Appearance for attorney" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AvailableAppsRaw, null)))));
